import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAddiction, IAddictionInitial } from "./addictionModel";
import {
  activeInactiveAddiction,
  createAddiction,
  deleteAddiction,
  getAddictionById,
  getAllActiveAddiction,
  getAllAddictions,
  updateAddiction,
} from "./services/addiction.services";

const initialState: IAddictionInitial = {
  loading: false,
  formLoading: false,
  error: "",
  AddictionList: [],
  AddictionID: null,
  AddictionDetail: {
    Name: "",
    IsActive: 1,
  },
};

export const addictionSlice = createSlice({
  name: "addiction",
  initialState,
  reducers: {
    clearAddictionDetails: (state) => {
      state.AddictionDetail = initialState.AddictionDetail;
    },
    setAddictionID: (state, action) => {
      state.AddictionID = action.payload;
    },
    clearAddictionID: (state) => {
      state.AddictionID = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllAddictions.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllAddictions.fulfilled,
      (state, action: PayloadAction<IAddiction[]>) => {
        state.loading = false;
        state.AddictionList = action.payload;
      }
    );
    builder.addCase(getAllAddictions.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AddictionList = [];
    });

    builder.addCase(getAllActiveAddiction.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveAddiction.fulfilled,
      (state, action: PayloadAction<IAddiction[]>) => {
        state.loading = false;
        state.AddictionList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveAddiction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.AddictionList = [];
    });

    builder.addCase(createAddiction.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createAddiction.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createAddiction.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(updateAddiction.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateAddiction.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateAddiction.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(deleteAddiction.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteAddiction.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteAddiction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(activeInactiveAddiction.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(activeInactiveAddiction.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(activeInactiveAddiction.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    builder.addCase(getAddictionById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getAddictionById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.AddictionDetail = action.payload;
    });
    builder.addCase(getAddictionById.rejected, (state, action) => {
      state.formLoading = false;
      state.AddictionDetail = initialState.AddictionDetail;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearAddictionDetails, setAddictionID, clearAddictionID } =
  addictionSlice.actions;
export default addictionSlice.reducer;
